// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fRTG","newExpiryDate":"styles_newExpiryDate__1aBq4","footer":"styles_footer__2eQhY"};